<template>
    <section class="content-contact">
        <div class="container">
            <div class="content-contact-link">
                <button tag="a" @click="hasHistory()
                    ? $router.go(-1)
                    : $router.push('/')" class="btn-return">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                        <defs>
                            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0" stop-color="#fece09"/>
                            <stop offset="1" stop-color="#f5891f"/>
                            </linearGradient>
                            <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                            <feOffset dy="6" input="SourceAlpha"/>
                            <feGaussianBlur stdDeviation="6" result="blur"/>
                            <feFlood flood-opacity="0.161"/>
                            <feComposite operator="in" in2="blur"/>
                            <feComposite in="SourceGraphic"/>
                            </filter>
                        </defs>
                        <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                            <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                            <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                            </g>
                            <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                        </g>
                    </svg>
                    <h3>Formulário de Contacto</h3>
                </button>
            </div>
            <div class="content-contact-elements">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="content-form-contact">
                            <form @submit.prevent="sendContact()" class="content-form-contact-body">
                                <div class="content-input">
                                    <input type="text" name="name" v-model="name" placeholder="Nome*" required/>
                                </div>
                                <div class="content-input">
                                    <input type="email" name="email" v-model="email" placeholder="E-mail*" required/>
                                </div>
                                <div class="content-input">
                                    <input type="text" name="telphone" v-model="phone" placeholder="Telefone*" maxlength="9"  @keypress="onlyNumbers" required/>
                                </div>
                                <div class="content-input">
                                    <textarea name="message" v-model="message" placeholder="Mensagem"></textarea>
                                </div>
                                <div class="content-input-check">
                                    <input type="checkbox" id="acceptedcom" v-model="acceptedcom" required>
                                    <label for="acceptedcom">
                                        Consinto, de forma livre, consciente e informada, que a Manuel Rui Azinhais Nabeiro, Unipessoal, Lda. recolha e trate os dados pessoais por mim fornecidos para ações de marketing e publicidade, nos termos melhor descritos na <a href="https://www.cafedasorte.pt/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank">Política de Privacidade</a>
                                    </label>
                                </div>
                                <div class="div-recaptcha"></div>
                                <div class="content-input-button">
                                    <button type="submit">Enviar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            message: '',
            acceptedcom: false,
        }
    },
    computed: {
        ...mapGetters(['user', 'isLoadingApi'])
    },
    methods: {
        hasHistory() {
            return window.history.length > 1;
        },
        async getUserData() {
            if(this.user){
                this.name = this.user.nome;
                this.email = this.user.email;
                this.phone = this.user.telemovel;
            }
        },
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
            }
        },
        async sendContact() {
            this.$store.dispatch("setIsLoadingApi", true);
            await axios.post('api/v1/chat/contact', {
                name: this.name,
                email: this.email,
                phone: this.phone,
                message: this.message,
                acceptedcom: this.acceptedcom,
            }).then((response) => {
                this.$store.dispatch("setIsLoadingApi", false);
                if(response.data.success === true){
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: 'Pedido de contacto enviado com sucesso!',
                        timer: 5000,
                    })
                    this.cleanForm();
                    this.$router.push('/home');
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Ocorreu um erro ao enviar o pedido de contacto!',
                        timer: 5000,
                    })
                }
            }).catch((error) => {
                console.log(error);
                this.$store.dispatch("setIsLoadingApi", false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao enviar o pedido de contacto!',
                    timer: 5000,
                })
            })
        },
        cleanForm() {
            this.message = '';
            this.acceptedcom = false;
        }
        
    },
    mounted() {
        this.getUserData();
        this.$store.dispatch("getUser");
    },
    beforeDestroy() {
        this.cleanForm();
    }
}
</script>

<style lang="scss">
.content-contact {
    margin-top: 210px;
    @media (max-width: 991px){
        margin-top: 170px;
    }
    &-link {
        button {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background: 0;
            border: 0;
            margin-left: -25px;
        }
    }
    &-elements {
        padding: 50px 0px 100px 0px;
        .content-support {
            @media (max-width: 991px){
                margin-bottom: 100px;
            }
            &--header {
                text-align: left;
                margin-bottom: 50px;
            }
            &--data {
                text-align: left;
                margin-bottom: 40px;
                h4 {
                    font-size: 28px;
                    font-family: 'Font Regular';
                    margin-bottom: 10px;
                }
                h5 {
                    font-size: 28px;
                    font-family: 'Font Bold';
                    margin-bottom: 0;
                }
                p {
                    font-size: 18px;
                    font-family: 'Font Regular';
                    text-transform: uppercase;
                    margin-bottom: 0;
                }
            }
        }
        .content-form-contact {
            &--header {
                text-align: left;
                margin-bottom: 50px;
                @media (max-width: 991px){
                    margin-bottom: 30px;
                }
            }
            &-body {
                .content-input {
                    input, textarea {
                        width: 100%;
                        height: 50px;
                        border: none;
                        background-color: var(--white);
                        border: 1px solid #BFBFBF;
                        text-align: center;
                        border-radius: 10px;
                        padding: 0 20px;
                        margin-bottom: 20px;
                        font-size: 18px;
                        font-family: "Font Regular";
                        color: var(--black);
                        text-align: left;
                        &::placeholder{
                            font-size: 18px;
                            font-family: "Font Regular";
                            color: var(--gray);
                        }
                    }
                    textarea {
                        display: block;
                        min-height: 120px;
                        padding: 15px 20px;
                        resize: none;
                    }
                }
                .content-input-check {
                    display: flex;
                    align-items: flex-start;
                    flex-direction: row;
                    gap: 0;
                    margin: 40px 0px;
                    label {
                        font-size: 14px;
                        a{
                            font-size: 14px;
                        }
                    }
                }
                .div-recaptcha {
                    margin: 40px;
                }
                .content-input-button{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    button {
                        width: 100%;
                        max-width: 340px;
                        height: 56px;
                        border-radius: 10px;
                        border: none;
                        background: rgb(254,206,9);
                        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                        color: black;
                        font-family: "Font Bold";
                        font-size: 18px;
                        text-transform: uppercase;
                        box-shadow: 0px 6px 12px rgba(0,0,0,0.16);
                        transition: 500ms;
                        @media (max-width: 991px){
                            max-width: 100%;
                            height: 53px;
                            font-size: 17px;
                        }
                        &:hover,
                        &:focus {
                            cursor: pointer;
                            box-shadow: 0px 6px 12px rgba(0,0,0,0.32);
                        }
                    }
                }
            }
        }
    }
}

</style>
